import React from 'react';
import './SectionHeader.css';

export interface SectionHeaderProps {
  title: string;
  // 見出しの行の右端に並べるボタン
  actions?: React.ReactNode;
}

// 物件の画面のように、画面の見出し（h1）を親が出している中で、各タブの中身の見出し（h2）と、そのすぐ右に操作のボタンを並べる
export const SectionHeader: React.FC<SectionHeaderProps> = function (props) {
  return (
    <div className="SectionHeader">
      <h2 className="SectionHeader-title">{props.title}</h2>
      <div className="SectionHeader-actions">{props.actions}</div>
    </div>
  );
};
